import { createFileRoute } from "@tanstack/react-router";
import { CampaignCreate } from "@/components/campaigns/CampaignCreate";
import { PermissionDeniedPage } from "@/components/team/PermissionDeniedPage";
import { useRole } from "@/hooks/use-role";
import { useSession } from "@/hooks/use-session";

export const Route = createFileRoute("/_app/_/campaigns/new")({
	component: NewCampaignPage,
});

function NewCampaignPage() {
	const { isReadWrite } = useRole();
	if (!isReadWrite) {
		return (
			<PermissionDeniedPage
				requiredRole="Read/Write"
				message="You need Read/Write or Admin access to create a campaign."
			/>
		);
	}
	return <NewCampaignPageInner />;
}

function NewCampaignPageInner() {
	const session = useSession();
	const campaignId = session.campaign?.id;
	if (!campaignId) {
		return (
			<div className="mx-auto max-w-3xl p-6">
				<p className="text-muted-foreground">
					No campaign found. Please complete onboarding first.
				</p>
			</div>
		);
	}
	return <CampaignCreate campaignId={campaignId} />;
}
